import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'
import _imports_1 from '@/assets/appstoreBadge.svg'
import _imports_2 from '@/assets/googleplayBadge.svg'


const _withScopeId = n => (_pushScopeId("data-v-26e61e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "download"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<h1 data-v-26e61e34>Start by downloading the mobile app</h1><div class=\"plattforms\" data-v-26e61e34><a target=\"_blank\" href=\"https://apps.apple.com/se/app/shipd-mobile/id6443850361?l=en\" data-v-26e61e34><img class=\"plattform\" src=\"" + _imports_1 + "\" alt=\"apple\" data-v-26e61e34></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=co.getshipd.mobile\" data-v-26e61e34><img class=\"plattform\" src=\"" + _imports_2 + "\" alt=\"android\" data-v-26e61e34></a></div>", 2)
const _hoisted_6 = {
  key: 1,
  class: "download"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Start by downloading the desktop client", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Then run the downloaded file and follow the installation process", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    ($setup.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.continueTour && $setup.continueTour(...args)))
          }, "Continue")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_ToggleButton, {
            defaultState: $setup.OSName == 'MacOS' ? true : false,
            onChange: $setup.toggleEvent,
            labelEnableText: "Windows",
            labelDisableText: "MacOS"
          }, null, 8, ["defaultState", "onChange"]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.continueTour && $setup.continueTour(...args)))
          }, _toDisplayString($setup.OSName == "MacOS" ? "Download for MacOS" : "Download for Windows"), 1),
          _hoisted_8
        ])),
    _createElementVNode("button", {
      class: "skip",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.skipWalktrough && $setup.skipWalktrough(...args)))
    }, "Skip walktrough")
  ]))
}